import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";
import { RootState } from "../store";

const initialState : {
    serviceTicketObject: any,
    status: APIRequestStatus,
    error: string | null,
} = {
    serviceTicketObject: {},
    status: APIRequestStatus.Idle,
    error: null
}

export const createServiceTicket = createAsyncThunk('serviceTicketState/createServiceTicket',
    async (desc: any[], thunkAPI) => {
        const rootState = (thunkAPI.getState() as RootState);
        const timestamp = new Date().toISOString();

        const response = await axios({
            method: 'post',
            url: "https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/service-ticket",
            data: {
                status: "DIMULAI",
                timestamp: timestamp,
                description: desc,
                phoneNumber: rootState.account.phoneNumber,
                userSub: rootState.account.sub,
                name: rootState.account.name
            }
        });

        return timestamp;
    }
)

export const fetchServiceTicket = createAsyncThunk('serviceTicketState/fetchServiceTicket',
    async (timestamp: string) => {
        const response = await axios({
            method: 'get',
            url: "https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/service-ticket",
            params: {
                timestamp: timestamp
            }
        });

        return response.data.ticketList; 
    }
)

export const updateServiceTicket = createAsyncThunk('serviceTicketState/updateServiceTicket',
    async (arg: {file: File, timestamp: string}) => {
        const {file, timestamp} = arg;

        let currentFileDraft: any = {};
        currentFileDraft.file = file;
        currentFileDraft.fileName = `resi_${timestamp}.${file.type.split("/")[1]}`;
        currentFileDraft.fileCategory = "general";
        currentFileDraft.fileDataType = file.type;

        const signedURLResponse = await axios({
            method: "post",
            url: "https://w3q706jlua.execute-api.ap-southeast-1.amazonaws.com/FileSystemAPIProduction/signedurl",
            data: currentFileDraft,
        });
        const uploadURL = signedURLResponse.data.uploadURL;

        const uploadResult = await axios({
            method: "put",
            url: uploadURL,
            data: currentFileDraft.file,
            headers: {
                "Content-Type": currentFileDraft.fileDataType,
            },
        });

        const responseUpdate = await axios({
            method: 'put',
            url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/service-ticket',
            data: JSON.stringify({
                serviceTicketObject: {
                    statusFinished: "NOT_FINISHED",
                    timestamp: timestamp,
                },
                buktiKirimURL: uploadURL.split("?")[0]
            })
        });
        
        return uploadURL.split("?")[0];
    }
)

export const serviceTicketSlice = createSlice({
    name: 'serviceTicketState',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(createServiceTicket.pending, (state, action) => {
                state.status = APIRequestStatus.RequestInProgress;
            })
            .addCase(createServiceTicket.fulfilled, (state, action) => {
                state.status = APIRequestStatus.Success;

                state.serviceTicketObject.timestamp = action.payload;
            })
            .addCase(createServiceTicket.rejected, (state, action) => {
                state.status = APIRequestStatus.Failure;
            })
            .addCase(fetchServiceTicket.pending, (state, action) => {
                state.status = APIRequestStatus.RequestInProgress;
            })
            .addCase(fetchServiceTicket.fulfilled, (state, action) => {
                state.status = APIRequestStatus.Success;

                state.serviceTicketObject = action.payload;
            })
            .addCase(fetchServiceTicket.rejected, (state, action) => {
                state.status = APIRequestStatus.Failure;
            })
            .addCase(updateServiceTicket.pending, (state, action) => {
                state.status = APIRequestStatus.RequestInProgress;
            })
            .addCase(updateServiceTicket.fulfilled, (state, action) => {
                state.status = APIRequestStatus.Success;

                state.serviceTicketObject.buktiKirimURL = action.payload;
                state.serviceTicketObject.status = "SEDANG_DIKIRIM_PELANGGAN";
            })
            .addCase(updateServiceTicket.rejected, (state, action) => {
                state.status = APIRequestStatus.Failure;
            })
    }
})

export default serviceTicketSlice.reducer